module.exports = __webpack_public_path__ + "static/media/c-dinner.96cecf80.jpg";